import {Image} from '@logistics-frontend/blocks/image'
import {tag2url} from '@logistics-frontend/utils'
import React, {memo} from 'react'

import {IconSpotWidgetConfig} from '../types'
import * as classes from './IconSpot.classes'

export const IconSpotWidget = memo(
  ({icon_spot}: IconSpotWidgetConfig): React.ReactElement => (
    <div className={classes.iconSpotWrapper}>
      <Image height={24} src={tag2url(icon_spot.icon.image_tag)} />
    </div>
  ),
)
